import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class BoothSelectionDialog
  * A component to allow users to add/remove booth icons
  * from a specified expo hall
  * @prop {object} booths - the booths in the hall
  * @prop {url} hallURL - the url to the hall
  * @prop {url} boothURL - the url to the booths
  * @prop {string} hallID - the id of the hall
  */
export default class BoothSelectionDialog extends Component {
  /** @constructor
    * Creates a new instance of BoothSelectionDialog
    */
  constructor(props) {
    super(props);
    this.state = {
      boothMap: {},
      boothList: [],
    }
    this.handleBoothCheck = this.handleBoothCheck.bind(this)
  }
  /** @method componentWillMount
    * Connects the component to firebase to retrieve
    * all booths in the expo.
    */
  componentWillMount() {
    this.boothRef = firebase.database().ref(this.props.boothURL);
    this.boothRef.on('value', snapshot => {
      var boothMap = snapshot.val();
      var boothList = [];
      for(var key in boothMap) {
        var booth = {
          id: key,
          name: boothMap[key].metadata.name,
          image: boothMap[key].metadata.icon,
          x: 50,
          y: 50,
          url: `/hall/${this.props.hallID}/booth/${key}`
        }
        boothMap[key] = booth;
        boothList.push(booth);
      }
      boothList = boothList.sort((a,b) => a.name.localeCompare(b.name));
      this.setState({
        boothMap: boothMap,
        boothList: boothList
      });
    })
  }
  /** @method componentWillUnmount
    * Disconnects the component from firebase
    */
  componentWillUnmount() {
    this.boothRef.off();
  }
  /** @method handleBoothCheck
    * Event handler to add or remove a booth from the hall
    */
  handleBoothCheck(event) {
    var updates = {
      [`${this.props.boothURL}/${event.target.value}/halls/${this.props.hallID}`]: event.target.checked ? this.props.name : null,
      [`${this.props.hallURL}/booths/${event.target.value}`]: event.target.checked ? this.state.boothMap[event.target.value] : null
    }
    firebase.database().ref().update(updates);
  }
  /** @method render
    * Renders the component
    */
  render(){
    if(!this.props.show) return null;
    const boothChecks = this.state.boothList.map(booth => (
      <label key={booth.id} htmlFor={`booth-${booth.id}`}>
        <input type="checkbox"
          name="boothID"
          value={booth.id}
          id={`booth-${booth.id}`}
          checked={this.props.booths[booth.id]}
          onChange={this.handleBoothCheck}
          />
        {booth.name}
      </label>
    ));
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}>
                <FontAwesome name="times"/>
              </button>
            </div>
            <h1>Selected Booths</h1>
            <div className="booth-list-checkboxes">
              {boothChecks}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BoothSelectionDialog.propTypes = {
  booths: PropTypes.object.isRequired,
  hallID: PropTypes.string.isRequired,
  hallURL: PropTypes.string.isRequired,
  boothURL: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/hall-editor/booth-selection-dialog.js